var render = function render(){var _vm=this,_c=_vm._self._c;return _c('violation-rule-form',{attrs:{"rule":_vm.rule}})
}
var staticRenderFns = []

export { render, staticRenderFns }